import WritingMessage from '../components/writingMessage/WritingMessage';

function PostIdMessage() {
  return <WritingMessage />;
}

export default PostIdMessage;
